/*
  ============================================================
  THE CHARISMA EDIT — Shared JavaScript
  File: assets/charisma-blog.js
  ============================================================
  Handles:
  - Category filter pills (works cross-section with data attributes)
  - Runs once even if script tag is loaded multiple times
  ============================================================
*/

(function () {
  'use strict';

  // Guard: run only once per page load
  if (window.__charismaInit) return;
  window.__charismaInit = true;

  function initFilter() {
    const pills = document.querySelectorAll('.charisma-filter__pill');
    if (!pills.length) return;

    // Collect ALL filterable cards from every section on the page
    function getAllCards() {
      return document.querySelectorAll('.charisma-card[data-category]');
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        const filter = pill.dataset.filter;

        // Update active pill state
        pills.forEach(function (p) {
          p.classList.remove('charisma-filter__pill--active');
        });
        pill.classList.add('charisma-filter__pill--active');

        // Show / hide cards across all grids on page
        getAllCards().forEach(function (card) {
          if (filter === 'all' || card.dataset.category === filter) {
            card.removeAttribute('data-hidden');
            card.style.display = '';
          } else {
            card.setAttribute('data-hidden', 'true');
            card.style.display = 'none';
          }
        });
      });
    });
  }

  // Init on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFilter);
  } else {
    initFilter();
  }

  // Re-init on Shopify theme editor section load/reorder
  document.addEventListener('shopify:section:load', initFilter);

})();
